<div class="po-row po-mb-4 fundoLogo">
    <img alt="logo" class="po-navbar-logo-image " src="./assets/image/logo-solida.png">
  </div>
  <po-page-edit
    p-title="Atualização Cadastral - Fornecedor"
    [p-disable-submit]="validForm()"
    (p-save)="openModalConfirmar()"
  >
    <form #formCadastroFornecedor="ngForm">
      <div class="po-row">
          <div class="po-lg-12">
              <h1 class="po-font-subtitle">Identificação</h1>
              <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Código/Loja" [p-value]="fornecedorDto.fornecedor.CA2COD"></po-info>
              <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="CNPJ/CPF" [p-value]="utilService.formatarCGC(fornecedorDto.fornecedor.CA2CGC)"></po-info>
              <po-input
                class="po-md-4"
                name="CA2NOME"
                [(ngModel)]="fornecedorDto.fornecedor.CA2NOME"
                p-help="{{fornecedorOriginal.CA2NOME||'-'}}"
                p-label="Razão Social (*)"
                p-required
                [p-maxlength]="40"
                [p-minlength]="5">
              </po-input>
              <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Inscrição Estadual" [p-value]="fornecedorDto.fornecedor.CA2INSCR"></po-info>
              <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Inscrição Municipal" [p-value]="fornecedorDto.fornecedor.CA2INSCRM"></po-info>
            </div>
            <div class="po-lg-12">

              <h1 class="po-font-subtitle">Endereço</h1>
              <po-input
                class="po-md-2"
                name="CA2CEP"
                [(ngModel)]="fornecedorDto.fornecedor.CA2CEP"
                p-help="{{fornecedorOriginal.CA2CEP||'-'}}"
                p-label="CEP (*)"
                p-mask="99.999-999"
                p-required
                (p-change)="alteraCep()"
                [p-maxlength]="10"
                [p-minlength]="10">
              </po-input>
              <po-input
                class="po-md-6"
                name="CA2END"
                [(ngModel)]="fornecedorDto.fornecedor.CA2END"
                p-help="{{fornecedorOriginal.CA2END||'-'}}"
                p-label="Logradouro (*)"
                p-required
                [p-maxlength]="40"
                [p-minlength]="10">
              </po-input>
              <po-input
                class="po-md-3"
                name="CA2BAIRRO"
                [(ngModel)]="fornecedorDto.fornecedor.CA2BAIRRO"
                p-help="{{fornecedorOriginal.CA2BAIRRO||'-'}}"
                p-label="Bairro (*)"
                p-required
                [p-maxlength]="30"
                [p-minlength]="0">
              </po-input>
              <po-select
                class="po-md-3"
                name="CA2EST"
                [(ngModel)]="fornecedorDto.fornecedor.CA2EST"
                p-help="{{fornecedorOriginal.CA2EST||'-'}}"
                p-label="Estado (*)"
                [p-required]="true"
                [p-disabled]="true"
                [p-options]="listaEstado">
              </po-select>
              <po-lookup
                class="po-md-4"
                name="CA2COD_MUN"
                [(ngModel)]="fornecedorDto.fornecedor.CA2COD_MUN"
                p-help="{{fornecedorOriginal.CA2COD_MUN||'-'}}"
                p-field-label="CCC2MUN"
                p-field-value="CCC2CODMUN"
                p-label="Município IBGE (*)"
                [p-columns]="columnsMunicipioIBGEFilters"
                [p-field-format]="fieldFormaterMunicipioIBGEFilters"
                [p-filter-service]="municipioIBGEService"
                [p-advanced-filters]="advancedMunicipioIBGEFilters"
                [p-literals]="{ modalTitle: 'MunicipioIBGE' }"
                (p-selected)="municipioIBGESelecionado($event)"
              >
              </po-lookup>

          </div>
          <div class="po-lg-12">

            <h1 class="po-font-subtitle">Contato</h1>
            <po-input
              class="po-md-2"
              name="CA2DDD"
              [(ngModel)]="fornecedorDto.fornecedor.CA2DDD"
              p-help="{{fornecedorOriginal.CA2DDD||'-'}}"
              p-label="DDD (*)"
              p-mask="99"
              p-required
              [p-maxlength]="2"
              [p-minlength]="2">
            </po-input>
            <po-input
              class="po-md-3"
              name="CA2TEL"
              [(ngModel)]="fornecedorDto.fornecedor.CA2TEL"
              p-help="{{fornecedorOriginal.CA2TEL||'-'}}"
              p-label="Telefone (*)"
              p-required
              [p-maxlength]="15"
              [p-minlength]="8">
            </po-input>
          </div>
          <div class="po-lg-12">
            <po-input
              class="po-md-3"
              name="CA2FAX"
              [(ngModel)]="fornecedorDto.fornecedor.CA2FAX"
              p-help="{{fornecedorOriginal.CA2FAX||'-'}}"
              p-label="FAX"
              [p-maxlength]="15"
              [p-minlength]="0">
            </po-input>
            <po-input
              class="po-md-4"
              p-icon="po-icon-mail"
              name="CA2EMAIL"
              [(ngModel)]="fornecedorDto.fornecedor.CA2EMAIL"
              p-help="{{fornecedorOriginal.CA2EMAIL||'-'}}"
              p-label="Email (*)"
              p-required
              p-placeholder="example@domain.com"
              [p-maxlength]="100"
              [p-minlength]="0">
            </po-input>
            <po-url
              class="po-md-4"
              name="CA2HPAGE"
              [(ngModel)]="fornecedorDto.fornecedor.CA2HPAGE"
              p-help="{{fornecedorOriginal.CA2HPAGE||'-'}}"
              p-label="Home Page"
              p-placeholder="www.domain.com"
              [p-maxlength]="30"
              [p-minlength]="0">
            </po-url>
          </div>
          <div class="po-lg-12">

            <h1 class="po-font-subtitle">Dados Pagamento</h1>
            <po-input
              class="po-md-2"
              name="CA2BANCO"
              [(ngModel)]="fornecedorDto.fornecedor.CA2BANCO"
              p-help="{{fornecedorOriginal.CA2BANCO||'-'}}"
              p-label="Banco"
              [p-minlength]="3"
              [p-maxlength]="3"
            >
            </po-input>
            <po-input
              class="po-md-2"
              name="CA2AGENCIA"
              [(ngModel)]="fornecedorDto.fornecedor.CA2AGENCIA"
              p-help="{{fornecedorOriginal.CA2AGENCIA||'-'}}"
              p-label="Agência"
              [p-minlength]="4"
              [p-maxlength]="4"
            >
            </po-input>
            <!--<po-input
              class="po-md-1"
              name="CA2DVAGE"
              [(ngModel)]="fornecedorDto.fornecedor.CA2DVAGE"
              p-help="{{fornecedorOriginal.CA2DVAGE||'-'}}"
              p-label="DV Agencia"
              [p-maxlength]="1">
            </po-input>-->
            <po-input
              class="po-md-2"
              name="CA2NUMCON"
              [(ngModel)]="fornecedorDto.fornecedor.CA2NUMCON"
              p-help="{{fornecedorOriginal.CA2NUMCON||'-'}}"
              p-label="Conta"
              [p-maxlength]="10">
            </po-input>
            <!--<po-input
              class="po-md-1"
              name="CA2DVCTA"
              [(ngModel)]="fornecedorDto.fornecedor.CA2DVCTA"
              p-help="{{fornecedorOriginal.CA2DVCTA||'-'}}"
              p-label="DV Conta"
              [p-maxlength]="1">
            </po-input>-->
          </div>
            <div class="po-row po-mt-2">
              <po-textarea class="po-md-12"
                           name="observacao"
                           [(ngModel)]="fornecedorDto.COBSERVACAO"
                           p-label="Observação:"
                           >
              </po-textarea>
          </div>
        </div>
      </form>
  </po-page-edit>
